import React from 'react';
import './SharePicComponent.scss';
import {showLoading, hideLoading} from "../../asstes/js/IntegratedProcessing";

class ShareUserPicComponent extends React.Component {
	state = {
		qrCode: '',
		cashValue: this.props.cashValue
	}

	UNSAFE_componentWillMount() {
		showLoading('海报生成中...')
		setTimeout(() => {
			this.createQrcode()
		}, 500)
	}

	createQrcode = () => {
		let _this = this
		let {canvasWidth, canvasHeight, createPostUrl} = this.props
		let options = {
			text: createPostUrl,
			width: 230,
			height: 230,
			codeWidth: 230,
			codeHeight: 230,
			top: 0,
			left: 0,
			// width: 240,
			// height: 240,
			// codeWidth: 200,
			// codeHeight: 200,
			// top: 20,
			// left: 20,
			colorDark: '#9e001d',
			materials: {
				logo: require('./logo.png')
			}
		}

		/** when the artqrcode loaded, run this function */
		function callBack(status) {
			let url = ''
			setTimeout(() => {
				let dom = document.getElementById('qrCode')
				url = dom && dom.querySelector('img').src
				// url && console.log(url);
				_this.setState({
					qrCode: url
				}, () => {
					_this.draw(canvasWidth, canvasHeight)
				})
			}, 200)
		}

		/* eslint-disable */
		new QRCode(document.getElementById("qrCode"), options, callBack);
	}

	getPixelRatio = (context) => {
		var backingStore = context.backingStorePixelRatio
			|| context.webkitBackingStorePixelRatio
			|| context.mozBackingStorePixelRatio
			|| context.msBackingStorePixelRatio
			|| context.oBackingStorePixelRatio
			|| context.backingStorePixelRatio || 1;
		return ((window.devicePixelRatio || 1) / backingStore) * 1.25;
	}


	draw = (originCanvasWidth, originCanvasHeight) => {
		let {qrCode, cashValue} = this.state
		let _this = this

		// Canvas居中写字，参数（context对象，要写的字，字体，颜色，绘制的高度）
		function canvas_text(_paint, _text, _fontSize, _color, _width, _height) {
			_paint.font = _fontSize;
			_paint.fillStyle = _color;
			_paint.textAlign = "center";
			_paint.textBaseline = "middle";
			_paint.fillText(_text, _width - ctx.measureText(_text).width / 2, _height);
		}

		function getQrCode() {
			let imgW = ''
			let imgH = ''
			let img = new Image();
			img.src = qrCode
			img.onload = function () {
				imgW = img.width * ratio;
				imgH = img.width * ratio;
				// console.log(img.width, imgW);
				// console.log((canvasWidth * (304 / 1080)));
				ctx.drawImage(this, 0, 0, imgW * 1.2, imgH * 1.2,
					(originCanvasHeight)*0.348, (originCanvasHeight) * 0.737, canvasWidth * (200 / 750), canvasWidth * (200 / 750));
				let data = document.getElementById('shareCanvas').toDataURL("image/jpeg")
				_this.props.isLoad && _this.props.isLoad()
				document.getElementById('showShareCanvas').src = data
				document.getElementById('showShareCanvas').style.display = 'block'
				hideLoading()
			}
		}

		const canvas = document.getElementById('shareCanvas')
		let ctx = canvas.getContext('2d');
		let img = new Image();
		let ratio = this.getPixelRatio(ctx);
		canvas.setAttribute('width', originCanvasWidth * ratio);
		canvas.setAttribute('height', originCanvasHeight * ratio);
		let canvasWidth = originCanvasWidth * ratio
		let canvasHeight = originCanvasHeight * ratio
		let imgW = ''
		let imgH = ''
		ctx.scale(ratio, ratio);
		img.src = require('./test1.jpg')
		img.onload = function () {
			imgW = img.width * ratio;
			imgH = img.height * ratio;
			ctx.drawImage(this, 0, 0, imgW, imgH,
				0, 0, canvasWidth, canvasHeight);
			getQrCode()
			canvas_text(ctx, cashValue, `bold ${30/ (ratio > 2 ? 1.6 : 1)}px Helvetica`,
				"#fcfe52", originCanvasWidth / 2.1, (originCanvasHeight) * 0.493);
		}
	}

	render() {
		let {canvasWidth, canvasHeight} = this.props
		let hideStyle = {
			width: '1px',
			height: '1px',
			opacity: .1
		}
		return (
			<>
				<img style={{display: 'none'}} id="showShareCanvas" className="canvas-change-img" src="" alt=""/>
				<canvas style={hideStyle} id="shareCanvas" width={canvasWidth} height={canvasHeight}></canvas>
				<div id="qrCode" style={hideStyle}></div>
			</>
		);
	}
}

export default ShareUserPicComponent;
